import { useStoreSalidas } from "./useStoreSalidas";
import Calendario from "../../ComponentesGlobales/Calendario";
import moment from "moment";
import ListaDesplegable from "../../ComponentesGlobales/ListaDesplegable";
import { InputNumber } from "primereact/inputnumber";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { MensajeInfo } from "../../componentes/FuncionesLocales";

export default function SalidasTab1() {
    const Mercaderia = useStoreSalidas((state) => state.Mercaderia);
    const Lote = useStoreSalidas((state) => state.Lote);
    const Fecha = useStoreSalidas((state) => state.Fecha);
    const Unidades = useStoreSalidas((state) => state.Unidades);
    const Kilos = useStoreSalidas((state) => state.Kilos);
    const FechaVencimiento = useStoreSalidas((state) => state.FechaVencimiento);
    const Etiquetas = useStoreSalidas((state) => state.Etiquetas);
    const Proceso = useStoreSalidas((state) => state.Proceso);
    const ListaProcesos = useStoreSalidas((state) => state.ListaProcesos);
    const BuscandoProcesos = useStoreSalidas((state) => state.BuscandoProcesos);
    const ListaMercaderias = useStoreSalidas((state) => state.ListaMercaderias);
    const BuscandoMercaderia = useStoreSalidas((state) => state.BuscandoMercaderia);
    const Procesando = useStoreSalidas((state) => state.Procesando);
    const ListaUnidades = useStoreSalidas((state) => state.ListaUnidades);
    const buscandoUnidades = useStoreSalidas((state) => state.buscandoUnidades);
    const Unidad = useStoreSalidas((state) => state.Unidad);
    const FechasConSalidas = useStoreSalidas((s) => s.FechasConSalidas); 
    const ListaLotes = useStoreSalidas((s) => s.ListaLotes);
    const BuscandoLotes = useStoreSalidas((s) => s.BuscandoLotes);



    

    useEffect(() => {
        if (Mercaderia && Mercaderia.Id && Mercaderia.Id > 0) {
            useStoreSalidas.getState().getUnidadPorDefecto();
        }
        else {
            useStoreSalidas.setState({ Unidad: { Id: 3, sCodigo: "P", sDescripcion: "Kilos" } });
        }
    }, [Mercaderia]);

    const Guardar = () => {
        if (
            moment(Fecha).format("YYYYMMDD") > moment(FechaVencimiento).format("YYYYMMDD")
        ) {
            MensajeInfo("La fecha de vencimiento no puede ser anterior a la fecha de ingreso.");
            return;
        }
        if (!Proceso || String(Proceso) === "") {
            MensajeInfo("Debe seleccionar un proceso.");
            return;
        }
        if (!Unidad || String(Unidad) === "") {
            MensajeInfo("Debe seleccionar una unidad.");
            return;
        }
        if (!Mercaderia || String(Mercaderia) === "") {
            MensajeInfo("Debe seleccionar una mercadería.");
            return;
        }
        if (Number(Unidades) <= 0 || Number(Kilos) <= 0) {
            MensajeInfo("La cantidad y el peso deben ser mayores a 0.");
            return;
        }
        useStoreSalidas.getState().insert();
    };
    const [open, setOpen] = useState(false);

    

    return (
        <>
            <div

                className="formulario-salida "
            >
                <div className="prod-bloque-form">
                    <div className="bloque-cabecera">
                        <h3 className="ing-subtitulo">Proceso Productivo</h3>

                        <button
                            className="btn-limpiar"
                            onClick={() => useStoreSalidas.getState().limpiezaTotal()}
                            title="Limpiar campos"
                        >
                            <i className="pi pi-eraser" aria-hidden="true" /><span>Limpiar</span>
                        </button>

                    </div>
                    <ListaDesplegable
                        Lista={ListaProcesos}
                        Buscando={BuscandoProcesos}
                        setValor={(e) => useStoreSalidas.setState({ Proceso: e })}
                        Seleccionado={Proceso}
                        TituloNoSeleccionado={"Nuevo Proceso"}
                    />
                    <div className="camp-o">
                        <label htmlFor="productoNombre">Semielaborado / Producto:</label>
                    </div>
                    <ListaDesplegable
                        Lista={ListaMercaderias}
                        Buscando={BuscandoMercaderia}
                        setValor={(e) => useStoreSalidas.setState({ Mercaderia: e })}
                        Seleccionado={Mercaderia}
                        TituloNoSeleccionado={"Nueva mercadería"}
                    />
                    <div className="prod-campos" style={{ marginBottom: "8px" }}>
                        <div >
                            <div className="camp-o">
                                {!Fecha && <span className="mensaje-obligatorio">*</span>}
                                <label htmlFor="fecha">Fecha de Producción</label>
                            </div>
                            <Calendario
                                Fecha={Fecha}
                                setFecha={(fecha) => useStoreSalidas.setState({ Fecha: fecha })}
                                highlightedDates={FechasConSalidas}
                            />
                        </div>
                        <div>
                            <label htmlFor="vencimiento">Vencimiento</label>
                            <Calendario
                                Fecha={FechaVencimiento}
                                setFecha={(fecha) =>
                                    useStoreSalidas.setState({ FechaVencimiento: fecha })
                                }
                            />
                        </div>
                    </div>

                    <div>
                        <div className="ing-campo">
                            <label htmlFor="lote" >Lote de fabricación:</label>
                        </div>
                        <ListaDesplegable
                        Lista={ListaLotes}
                        Buscando={BuscandoLotes}
                        setValor={(e) => useStoreSalidas.setState({ Lote: e })}
                        Seleccionado={Lote}
                        TituloNoSeleccionado={"Debe Seleccionar un Lote valido"}
                    />
                    </div>



                    <div className="prod-campos">

                        <div className="ing-campo" style={{ marginBottom: "35px" }}>
                            <div className="camp-o" >
                                <span className="mensaje-obligatorio">*</span>
                                <label htmlFor="kilos">Cantidad</label>
                            </div>
                            <input
                                type="number"
                                name="kilos"
                                placeholder="0000"
                                value={Kilos}
                                onChange={(e) =>
                                    useStoreSalidas.setState({ Kilos: e.target.value })
                                }
                            />
                        </div>

                        <div className="ing-campo" >
                            <div className="camp-o">
                                {!Unidad || !Unidad.Id || Unidad === "" && (
                                    <span className="mensaje-obligatorio">*</span>
                                )}
                                <label htmlFor="productoNombre">Medida</label>
                            </div>
                            <ListaDesplegable Lista={ListaUnidades} Buscando={buscandoUnidades}
                                setValor={(e) => useStoreSalidas.setState({ Unidad: e })}
                                Seleccionado={Unidad} TituloNoSeleccionado={"Nueva unidad"} SoloLectura={Mercaderia && Mercaderia.Id && Mercaderia.Id > 0} />
                        </div>



                        {/* <button onClick={() => setOpen(true)} style={{ margin: '4px', padding: '0px', width: '10px' }}>
                            <i
                                className="pi pi-info-circle"
                                title='Info'
                                style={{ color: '#545454', fontSize: '1rem', alignContent: 'center', marginLeft: '4px', cursor: 'pointer' }}>
                            </i>
                        </button> */}

                    </div>

                    <div className="ing-campo-repetir input-repetir" style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="camp-o">
                            <label>Repetir:</label>
                        </div>

                        <div style={{ display: 'flex' }}>
                            <InputNumber inputId="minmax"
                                inputStyle={{ backgroundColor: 'white', width: '100%', color: 'black' }}
                                value={Etiquetas} onValueChange={(e) => useStoreSalidas.setState({ Etiquetas: e.value })} min={0} max={50} />

                            {open && (
                                <div className="tutorial">
                                    <div>
                                        <button
                                            onClick={() => setOpen(false)}
                                            className="btn-cerrar-tutorial"
                                            style={{ color: 'white', background: '#545454', borderRadius: '5px', padding: '3px', width: '16px' }}
                                        >
                                            ✕
                                        </button>

                                        <div style={{ marginTop: '1.5rem' }}>
                                            <img
                                                src={"/Imagenes/InfoRepetir.jpeg"}
                                                className={`video-tutorial ${open ? "show" : ""}`}
                                                style={{ width: "300px", height: "450px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="camp-o" style={{ width: '60px', marginLeft: '8px' }}>
                            <p style={{ fontSize: '14px', margin: '3px 0px' }}>{Etiquetas === 1 ? "Vez" : "Veces"}</p>
                        </div>
                    </div>

                    <span className="mensaje-obligatorio" style={{ margin: "0px" }}>* Campo obligatorio</span>

                    <BlockUI blocked={Procesando}
                        template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >
                        <div className="salidas-cta" style={{ display: "flex", justifyContent: "center", }}>
                            <button onClick={Guardar} type="submit" style={{ backgroundColor: 'var(--app-brand)', color: 'white', width: '100%', fontSize: '1rem', padding: '12px 16px', borderRadius: '12px' }}>Agregar</button>
                        </div>
                    </BlockUI>

                </div>

            </div>
        </>
    );
}
